import {
  Generated,
  GeneratedAlways,
  Insertable,
  Selectable,
  Updateable,
} from 'kysely';
import { z, zTimestamp } from '@harvestiq/zod';
import { CampaignRecipientStatus } from '@harvestiq/constants';
import { expectTypeOf } from 'expect-type';
import {
  DbTimestampGenerated,
  DbTimestampGeneratedAlways,
  DbTimestampNullable,
} from '@harvestiq/utils';

export interface CampaignRecipientsTable {
  id: GeneratedAlways<string>;
  campaignId: string;
  userId: string;
  status: Generated<CampaignRecipientStatus>;
  sendEmail: boolean | null;
  sendSms: boolean | null;
  createdAt: DbTimestampGenerated;
  updatedAt: DbTimestampGeneratedAlways;
  deletedAt: DbTimestampNullable;
}

export type DbCampaignRecipients = Selectable<CampaignRecipientsTable>;
export type DbCampaignRecipientsInsert = Insertable<CampaignRecipientsTable>;
export type DbCampaignRecipientsUpdate = Updateable<CampaignRecipientsTable>;

export const dbCampaignRecipientsSchema = z.object({
  id: z.string().uuid(),
  campaignId: z.string().uuid(),
  userId: z.string().uuid(),
  status: z.nativeEnum(CampaignRecipientStatus),
  sendEmail: z.boolean().nullable(),
  sendSms: z.boolean().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  deletedAt: z.coerce.date().nullable(),
});
type DbCampaignRecipientsSchemaType = z.output<
  typeof dbCampaignRecipientsSchema
>;

expectTypeOf<DbCampaignRecipients>().toMatchTypeOf<DbCampaignRecipientsSchemaType>();
expectTypeOf<keyof DbCampaignRecipientsSchemaType>().toEqualTypeOf<
  keyof DbCampaignRecipients
>();
